module.exports = __webpack_public_path__ + "static/img/cnd_federal.3cde30b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/cnd_federal.png
// module id = 831
// module chunks = 0